export const SCRUM_TEAM = 'Scrum' as const;
export const KANBAN_TEAM = 'Kanban' as const;

export const SINGLE_CUSTOM_FIELD_TYPE_KEY =
	'com.atlassian.jira.plugin.system.customfieldtypes:select';
export const MULTI_CUSTOM_FIELD_TYPE_KEY =
	'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';

export const SYSTEM_LABEL_FIELD_ID = 'labels';

export const CUSTOM_FIELD_OPTION_MISSED_ERROR = 'CUSTOM_FIELD_OPTION_MISSED';

export const FILTER_FIELD_ERROR = {
	NOT_FOUND: 'CUSTOM_FIELD_NOT_FOUND', // Custom field is permanently deleted that you cannot restore.
	TRASHED: 'CUSTOM_FIELD_TRASHED', // Custom field is in trash and would be deleted in 2 months after it's trashed. Admin could restore it.
	NOT_IN_PLAN: 'CUSTOM_FIELD_NOT_IN_PLAN', // Custom field is not found in plan settings.
	OPTION_NOT_FOUND: 'CUSTOM_FIELD_OPTION_NOT_FOUND', // Custom field option is either renamed or deleted in the admin page.
} as const;

export const MAX_ACTIVE_BOARDS = 2;

export const IP_BOARD_STORY_POINTS_PLANNING_UNIT = 'StoryPoints' as const;
export const IP_BOARD_HOURS_PLANNING_UNIT = 'Hours' as const;
export const IP_BOARD_DAYS_PLANNING_UNIT = 'Days' as const;
